/** authored by ChatGPT */

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function populateHandleBarLikeTemplatesWithData(str: string, obj: Record<string, any>): string {
  const regex = /{{(.*?)}}/g;
  const matches = str.match(regex);
  if (!matches) {
    return str;
  }
  for (let i = 0; i < matches.length; i++) {
    const key = matches[i].replace(/[{}]/g, '');
    if (obj.hasOwnProperty(key)) {
      str = str.replace(matches[i], obj[key]);
    }
  }
  return str;
}
